<div class="properties-panel">

    @if (dynamicsInitialized) {
        <!-- Current Chart Type Display -->
        <div class="current-chart-wrapper">
            @if (currentChart) {
                <div class="current-chart-item" (click)="openChartTypeDialog()">
                    <mat-icon class="list-icon"
                              [ngStyle]="{'transform': 'rotate(' + (currentChart.rotation || '0deg') + ')'}">
                        {{ currentChart.icon }}
                    </mat-icon>
                    <div class="list-content">
                        <span class="list-title">{{ currentChart.title }}</span>
                        <span class="list-category">{{ currentChart.category }}</span>
                    </div>
                    <button mat-icon-button class="mini-button" (click)="$event.stopPropagation(); openChartTypeDialog()"
                            [matTooltip]="'ai.changeChartType' | transloco">
                        <mat-icon>swap_horizontal_circle</mat-icon>
                    </button>
                </div>
            }
        </div>

        <div class="d-flex-center" style="margin: 5px auto;">
            <!-- Mode Selection Dropdown -->
            <mat-form-field appearance="outline" style="width: 200px;">
                <mat-label>{{ 'general.source' | transloco }}</mat-label>
                <mat-select [value]="source" (selectionChange)="onDataSourceChange($event.value)">
                    <mat-option value="fixed">
                        <mat-icon style="vertical-align: middle; margin-right: 8px;">dashboard_customize</mat-icon>
                        {{ 'ai.static' | transloco }}
                    </mat-option>
                    <mat-option value="ai">
                        <mat-icon style="vertical-align: middle; margin-right: 8px;">auto_awesome</mat-icon>
                        {{ 'ai.aiFeed' | transloco }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    }

    @if (dynamicsInitialized) {
        <div class="settings-section">
            <!-- AI Configuration Section -->
            @if (source === 'ai') {
                <div class="properties-section ai-section">
                    <div class="section-header">
                        <mat-icon class="section-icon">psychology</mat-icon>
                        <span class="section-title">ai configuration</span>
                    </div>

                    <div class="section-content">
                        <dynamic-form [fields]="aiConfigInit" (submit)="submitAiConfig($event)">
                        </dynamic-form>
                    </div>
                </div>
            } @else if (source === 'fixed') {
                <button mat-raised-button class="chart-editor-button" (click)="openChartEditor()">
                    <mat-icon>dashboard_customize</mat-icon>
                    {{ 'ai.editData' | transloco }}
                </button>
            }

            <!-- Chart Properties Section -->
            <div class="properties-section">
                <div class="section-header">
                    <mat-icon class="section-icon">bar_chart</mat-icon>
                    <span class="section-title">chart properties</span>
                </div>

                <div class="section-content">
                    <br>
                    <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
                    </dynamic-form>
                </div>
            </div>

            @if (sceneItem.Data[0].Chart[0]?.Label?.[0]?.Font && (sceneItem.Data[0].Chart[0].$.showLabel == '1' || sceneItem.Data[0].Chart[0].$.showLegend == '1')) {
                <!-- Label Font Selector Section -->
                <div class="properties-section">
                    <div class="section-header">
                        <mat-icon class="section-icon">font_download</mat-icon>
                        <span class="section-title">label settings</span>
                    </div>

                    <div class="section-content">
                        <app-font-selector #fontLoader (onChange)="onFontChanged($event, 'Label', 'Chart')"
                                           [setConfig]="{i_config: sceneItem, pickArray: 0}" [maxFontSize]="100" [hideAlignment]="true"
                                           [hideVerticalAlignment]="true" [hideFontFamily]="true"></app-font-selector>
                    </div>
                </div>
            }

            @if (sceneItem.Data[0].Chart[0]?.Value?.[0]?.Font && sceneItem.Data[0].Chart[0].$.showValue == '1') {

                <!-- Value Font Selector Section -->
                <div class="properties-section">
                    <div class="section-header">
                        <mat-icon class="section-icon">numbers</mat-icon>
                        <span class="section-title">value settings</span>
                    </div>

                    <div class="section-content">
                        <app-font-selector #valueFontLoader (onChange)="onFontChanged($event, 'Value', 'Chart')"
                                           [setConfig]="{i_config: sceneItem, pickArray: 1}" [maxFontSize]="100" [hideAlignment]="true"
                                           [hideVerticalAlignment]="true" [hideFontFamily]="true"></app-font-selector>
                    </div>
                </div>
            }

        </div>
    }
</div>

<!-- Chart Type Selector Dialog Template -->
<ng-template #chartTypeSelectorDialog>
    <div class="chart-type-dialog">
        <!-- Dialog Header -->
        <div class="section-header" mat-dialog-title>
            <mat-icon class="section-icon">bar_chart</mat-icon>
            <span class="section-title">{{ 'ai.chartGallery' | transloco }}</span>
            <button mat-icon-button class="close-button" mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <!-- Dialog Content -->
        <div mat-dialog-content class="dialog-content">
            <!-- Chart Gallery Header -->
            <div class="chart-gallery-header">
                <div class="header-row">
                    <div class="header-title">
                        <span class="chart-count">{{ filteredChartTypes.length }} {{ filteredChartTypes.length === 1 ? 'chart' : 'charts' }}</span>
                    </div>

                    <!-- View Mode Toggle -->
                    <button
                        mat-icon-button
                        class="view-mode-toggle-btn mini-button"
                        (click)="toggleViewMode()"
                        [title]="'Current: ' + viewModeLabel + ' (click to cycle)'">
                        <mat-icon>{{ viewModeIcon }}</mat-icon>
                    </button>
                </div>

                <!-- Search Filter -->
                <div class="chart-search">
                    <mat-icon class="search-icon">search</mat-icon>
                    <input
                        type="text"
                        class="search-input"
                        [(ngModel)]="chartFilterText"
                        placeholder="search charts..."
                        autocomplete="off"
                        (ngModelChange)="filter()">
                    @if (chartFilterText) {
                        <button mat-icon-button class="clear-btn" (click)="chartFilterText = ''; filter();"
                                title="Clear search">
                            <mat-icon>close</mat-icon>
                        </button>
                    }
                </div>
            </div>

            <!-- Chart Icons Grid -->
            <div class="chart-icons-container" [ngSwitch]="viewMode">
                <!-- Grid View -->
                <div *ngSwitchCase="'grid'" class="chart-icons grid-view">
                    @for (chart of filteredChartTypes; track chart.type) {
                        <button
                            mat-icon-button
                            class="chart-type-btn-grid"
                            [class.selected]="chartType === chart.type"
                            (click)="selectChartTypeFromDialog(chart.type)"
                            [title]="chart.title">
                            <mat-icon [ngStyle]="{'transform': 'rotate(' + (chart.rotation || '0deg') + ')'}">
                                {{ chart.icon }}
                            </mat-icon>
                        </button>
                    }
                </div>

                <!-- List View -->
                <div *ngSwitchCase="'list'" class="chart-list-view">
                    @for (chart of filteredChartTypes; track chart.type) {
                        <button
                            class="chart-list-item"
                            [class.selected]="chartType === chart.type"
                            (click)="selectChartTypeFromDialog(chart.type)">
                            <mat-icon class="list-icon"
                                      [ngStyle]="{'transform': 'rotate(' + (chart.rotation || '0deg') + ')'}">
                                {{ chart.icon }}
                            </mat-icon>
                            <div class="list-content">
                                <span class="list-title">{{ chart.title }}</span>
                                <span class="list-category">{{ chart.category }}</span>
                            </div>
                            @if (chartType === chart.type) {
                                <mat-icon class="check-icon">check_circle</mat-icon>
                            }
                        </button>
                    }
                </div>

                <!-- No Results State -->
                @if (filteredChartTypes.length === 0) {
                    <div class="no-results">
                        <mat-icon class="no-results-icon">search_off</mat-icon>
                        <p class="no-results-text">no charts found</p>
                        <p class="no-results-hint">try a different search term</p>
                    </div>
                }
            </div>
        </div>
    </div>
</ng-template>
